// Imports
import planMapping from './plan-mapping';


/** Determines whether a particular plan is a valid subscription plan */
export default function isValidSubscriptionPlan(plan: number): plan is (typeof planMapping)[keyof typeof planMapping] {
	return (Object.values(planMapping) as number[]).includes(plan);
}
